import React from 'react'
import PropTypes from 'prop-types'
import css from './confirm-cancel.css'

const ConfirmCancel = ({ isOpen, affirmCancellation, denyCancellation }) => {
  if (!isOpen) { return null }

  return (
    <div
      className={css.dialog}
    >
      <p>Cancel All Messages?</p>
      <div className={css.actions}>
        <button className={css.yes} onClick={affirmCancellation}>Yes</button>
        <button className={css.no} onClick={denyCancellation}>No</button>
      </div>
    </div>
  )
}

ConfirmCancel.propTypes =  {
  isOpen: PropTypes.bool.isRequired,
  affirmCancellation: PropTypes.func.isRequired,
  denyCancellation: PropTypes.func.isRequired,
}

export default ConfirmCancel



// WEBPACK FOOTER //
// ./src/components/Messages/Blasts/SelectedBlast/ConfirmCancel.js